import { render, staticRenderFns } from "./ServiceCenterReservations.vue?vue&type=template&id=8e32cb7a&scoped=true&"
import script from "./ServiceCenterReservations.vue?vue&type=script&lang=js&"
export * from "./ServiceCenterReservations.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCenterReservations.vue?vue&type=style&index=0&id=8e32cb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e32cb7a",
  null
  
)

export default component.exports